/* eslint-disable space-before-function-paren */
/* eslint-disable indent */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from 'react'
import { View } from 'react-native'
import isWeb from '../helpers/isWeb'
import { colours, breakpoints } from '../styles/constants'
import styled from 'styled-components'
import Scrollbar from 'react-scrollbars-custom'
import BreakpointWatcher from '../helpers/BreakpointWatcher'

const Scroll = {
  Wrapper: ({ style = {}, exceedsMediumBreakpoint, children, ...props }) => {
    const _style = {
      position: 'relative',
      marginVertical: 20,
      marginHorizontal: 0,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: colours.light,
      ...(exceedsMediumBreakpoint
        ? {
            marginRight: -15
          }
        : {}),
      ...style
    }

    return (
      <View style={_style} {...props}>
        {children}
      </View>
    )
  },

  Inner: styled(Scrollbar)`
    height: ${props => props.height}px !important;
    overflow: hidden;

    .ScrollbarsCustom-Wrapper {
      bottom: 0 !important;
      right: 20px !important;
    }

    .ScrollbarsCustom-Track {
      background: white !important;
      width: 20px !important;
      border-radius: 0 !important;
      height: calc(100% - 44px) !important;
      top: 50% !important;
      transform: translateY(-50%);
      border-left: 1px solid ${colours.light};
    }

    .ScrollbarsCustom-Thumb {
      display: block !important;
      border-radius: 0 !important;
      background: ${colours.light20} !important;
    }

    .ScrollbarsCustom-TrackY {
      display: block !important;
    }

    .ScrollbarsCustom-TrackX {
      display: none !important;
    }

    table {
      width: 100%;
    }

    .ReactTable {
      margin: 0;
      border: 0;
    }

    @media(max-width: ${breakpoints.medium - 1}px) {
      height: auto !important;
      overflow: auto !important;

      .ScrollbarsCustom-Wrapper,
      .ScrollbarsCustom-Scroller {
        position: static !important;
        overflow: auto !important;
      }

      .ScrollbarsCustom-TrackY {
        display: none !important;
      }
    }
  `,

  Button: isWeb && styled.button`
    appearance: none;
    border: 0;
    background: white url(${require('../images/arrow-up-scroll.png')}) center center / 11px 6px no-repeat;
    height: 23px;
    width: 20px;
    border-left: 1px solid ${colours.light};
    position: absolute;
    right: 0;
    z-index: 1;
    font-size: 0;
    cursor: pointer;

    ${props => props.direction === 'down'
      ? `
          bottom: 0;
          background-image: url(${require('../images/arrow-down-scroll.png')});
        `
      : `
          top: 0;
        `}

    @media(max-width: ${breakpoints.medium - 1}px) {
      display: none !important;
    }
  `
}

export default class ScrollBarTable extends React.Component {
  state = {
    exceedsMediumBreakpoint: false
  }

  componentDidMount() {
    BreakpointWatcher.addComponent(this)
  }

  componentWillUnmount() {
    BreakpointWatcher.removeComponent(this)
  }

  handleScroll = (direction = 'up') => {
    const scrollbar = this.scrollbar

    if (!scrollbar || !scrollbar.scrollValues) {
      return
    }

    const currentPosition = scrollbar.scrollValues.scrollTop
    const clientHeight = scrollbar.scrollValues.clientHeight
    const scrollHeight = scrollbar.scrollValues.scrollHeight
    const maxScrollTop = scrollHeight - clientHeight
    const step = 40

    if (direction === 'up') {
      scrollbar.scrollTo(null, Math.max(currentPosition - step, 0))
      return
    }

    scrollbar.scrollTo(null, Math.min(currentPosition + step, maxScrollTop))
  }

  render() {
    const { exceedsMediumBreakpoint } = this.state
    const { className, children, height, ...props } = this.props

    return (
      <Scroll.Wrapper
        exceedsMediumBreakpoint={exceedsMediumBreakpoint}
        className={className}
        {...props}
      >
        <Scroll.Button
          className="scroll-button"
          onClick={() => this.handleScroll('up')}
        >
          Up
        </Scroll.Button>

        <Scroll.Inner
          ref={ref => {
            this.scrollbar = ref
          }}
          height={Number(height)}
        >
          {children}
        </Scroll.Inner>

        <Scroll.Button
          className="scroll-button"
          onClick={() => this.handleScroll('down')}
          direction="down"
        >
          Down
        </Scroll.Button>
      </Scroll.Wrapper>
    )
  }

  static defaultProps = {
    height: 500
  }
}
